import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { addQueryParamsToUrl } from '../../Utils/utils';
import { updateComponentCTALink } from '../../Lib/redux/slices/components';
import { ComponentTypes } from '../../Data/Components';

/**
 * Cheq is a tool that helps us to understand if a user is a bot or not.
 * It is loaded on the parent page, and the parent page will update all links on the parent page with anr and anrId query parameters.
 * This component is responsible for updating the links within the chameleon iframe i.e. the URL of each CPC card and supplier card with the required params
 */
const CheqManager = () => {
  const dispatch = useDispatch();
  const components = useSelector((store) => store.components);
  const cheqData = useSelector((store) => store.userIdentities.cheqData);

  useEffect(() => {
    if (
      !cheqData ||
      !cheqData?.cheqRequestId ||
      !cheqData?.cheqThreatType ||
      !cheqData?.cheqThreatGroup ||
      !cheqData?.cheqAITrafficType ||
      !components
    ) {
      return;
    }

    Object.entries(components || {}).forEach(([componentId, component]) => {
      if (component.component.type === ComponentTypes.SUPPLIER_CARD) {
        const { cta_link_url } = component.component.additionalSettings;
        if (cta_link_url) {
          const newUrl = addQueryParamsToUrl({
            url: cta_link_url,
            params: {
              cri: cheqData.cheqRequestId,
              ctt: cheqData.cheqThreatType,
              ctg: cheqData.cheqThreatGroup,
              catt: cheqData.cheqAITrafficType,
              cheqIdentifier: cheqData.cheqRequestId,
            },
          });

          dispatch(
            updateComponentCTALink({
              componentId,
              newUrl,
            })
          );
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cheqData]);

  return null;
};

export default CheqManager;
